import classNames from 'classnames'
import { t } from 'i18next'
import type { CSSProperties } from 'react'
import { ReactElement } from 'react'
import { Icon } from '../icon'
import styles from './index.module.css'

export function IconLoading(props: { className?: string; style?: CSSProperties }): ReactElement {
  const className = classNames(styles.icon, props.className)

  return (
    <span role="status" aria-label={t('glow.loading') ?? ''}>
      <Icon className={className} style={props.style} icon="spinner-third" aria-hidden="true" />
    </span>
  )
}
